import { render, staticRenderFns } from "./D24.vue?vue&type=template&id=42673614&scoped=true"
import script from "./D24.vue?vue&type=script&lang=js"
export * from "./D24.vue?vue&type=script&lang=js"
import style0 from "./D24.vue?vue&type=style&index=0&id=42673614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42673614",
  null
  
)

export default component.exports